import { memo } from "react";

import { PlusIcon } from "./icons";

/**
 * HotelInfoSection: ホテル情報（FAQ アコーディオン）
 * ゲスト側 app/frontend/guest/_shared/src/components/facility-info/HotelInfoSection.astro
 * および AccordionItem.astro の逐語再現。
 */

type FaqItem = { title: string; description: string };

const DEFAULT_ITEMS: FaqItem[] = [
	{
		title: "よくあるご質問",
		description: "ご滞在に関するよくあるご質問と回答を記載します。",
	},
	{
		title: "お支払い方法",
		description: "ご利用いただけるお支払い方法の詳細を記載します。",
	},
];

type Props = {
	items?: FaqItem[];
};

export const HotelInfoSection = memo(({ items = DEFAULT_ITEMS }: Props) => {
	if (items.length === 0) return null;

	return (
		<div>
			<h3 className="mb-5 text-xl font-semibold text-zinc-800">ホテル情報</h3>
			<div className="border-t border-zinc-200">
				{items.map((info, idx) => (
					<details key={idx} className="group border-b border-zinc-200 last:border-b-0">
						<summary className="flex cursor-pointer list-none items-start justify-between gap-4 py-4 text-left text-sm font-medium text-zinc-800 [&::-webkit-details-marker]:hidden">
							<span>{info.title}</span>
							<PlusIcon
								size={24}
								className="shrink-0 translate-y-0.5 text-zinc-400 transition-transform duration-200 group-open:rotate-45"
							/>
						</summary>
						<div className="pb-4">
							<p className="whitespace-pre-wrap text-base leading-relaxed text-zinc-700">
								{info.description}
							</p>
						</div>
					</details>
				))}
			</div>
		</div>
	);
});

HotelInfoSection.displayName = "HotelInfoSection";
